export const styles = {
  WhiteBox: {
    fontSize: "14px",
    background: "#FFFFFF",
    padding: { xs: ".5rem", md: "1rem" },
    borderRadius: "5px",
    flex: 1,
    width: "100%",
    boxSizing: "border-box"
  },
} as const;